import { percentage } from "./utils";

const tokenUnits = {
  K: 10 ** 3,
  M: 10 ** 6,
  B: 10 ** 9,
  T: 10 ** 12,
  Q: 10 ** 15,
};

export async function getTokenInfo(contract, address, buyLinkPrefix, img) {
  const name = await contract.methods.name().call();
  const symbol = await contract.methods.symbol().call();
  const totalSupplyInWei = await contract.methods.totalSupply().call();
  const decimals = await contract.methods.decimals().call();
  const totalBurnedInWei = await contract.methods
    .balanceOf("0x000000000000000000000000000000000000dead")
    .call();
  const totalRouterTokensInWei = await contract.methods
    .balanceOf("0x54c5f8d206789c95392c0b6265e8ef5fc6746646")
    .call();
  const totalRouter = totalRouterTokensInWei / 10 ** decimals;
  const totalSupply = totalSupplyInWei / 10 ** decimals;
  const totalBurned = totalBurnedInWei / 10 ** decimals;
  const percentageBurned = percentage(totalBurnedInWei, totalSupplyInWei);
  const percentageRouter = percentage(totalRouterTokensInWei, totalSupplyInWei);
  let holderInfo = {
    isSet: false,
    balanceInWei: null,
    balance: null,
    balanceFmt: null,
  };
  const balance = await contract.methods
    .balanceOf(window.ethereum.selectedAddress)
    .call();
  holderInfo.isSet = true;
  holderInfo.balanceInWei = balance;
  holderInfo.balance = holderInfo.balanceInWei / 10 ** decimals;
  holderInfo.balanceFmt = formatTokenNumber(holderInfo.balance);

  return {
    contract,
    name,
    symbol,
    totalSupplyInWei,
    address,
    decimals,
    totalBurnedInWei,
    totalBurned,
    percentageBurned,
    percentageRouter,
    totalRouterInWei: totalRouterTokensInWei,
    totalSupplyFmt: formatTokenNumber(totalSupply),
    totalBurnedFmt: formatTokenNumber(totalBurned),
    totalRouterFmt: formatTokenNumber(totalRouter),
    buyLink: `${buyLinkPrefix}${address}`,
    img,
    holderInfo,
  };
}

function formatTokenNumber(value) {
  if (value < tokenUnits.K) {
    return humanReadable(value, tokenUnits.K, "K");
  } else if (value < 100 * tokenUnits.M) {
    return humanReadable(value, tokenUnits.M, "Million");
  } else if (value < 100 * tokenUnits.B) {
    return humanReadable(value, tokenUnits.B, "Billion");
  } else if (value < 100 * tokenUnits.T) {
    return humanReadable(value, tokenUnits.T, "Trillion");
  } else {
    return humanReadable(value, tokenUnits.Q, "Quadrillion");
  }
}

function humanReadable(input, divisor, suffix) {
  const inputDiv = input / divisor;
  return `${inputDiv.toFixed(2)} ${suffix}`;
}
